// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { cooInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const COOUpdate = ({ title }) => {
//   // Extracting cooId using regular expressions
//   const location = useLocation();
//   const cooId = location.pathname.match(/\/update-coo\/(\d+)/)?.[1];

//   // Initializing state
//   // const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [options, setOptions] = useState([]);
//   const [selectedoptions, setSelectedOptions] = useState([]);
//   const [roptions, setRoptions] = useState([]);
//   const [selectedRoles, setSelectedRoles] = useState([
//     { value: "2", label: "COO" },
//   ]);

//   const [selectedStatus, setSelectedStatus] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCOO = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/user/${cooId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch user data");
//         }
//         const data = await response.json();
//         console.log("Fetched data:", data);

//         // Fix roles
//         const rnames = data.data.role_names.split(",");
//         const rid = data.data.role_id.split(",");
//         const roleList = rnames.map((name, i) => ({
//           value: rid[i],
//           label: name,
//         }));

//         // Fix center
//         setSelectedOptions({
//           value: data.data.center_id,
//           label: data.data.center_name,
//         });

//         // Fix status
//         setSelectedStatus(
//           statusOptions.find((opt) => opt.value == data.data.status)
//         );

//         setSelectedRoles(roleList);
//         setInputValues(data.data);
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (cooId) {
//       fetchCOO();
//     }
//   }, [cooId]);

//   const handleRoleSelectChange = (selectedOptions) => {
//     setSelectedRoles(selectedOptions);
//   };
//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };
//   const handleCenterSelectChange = (selectedOption) => {
//     setSelectedOptions(selectedOption); // Show selected center in UI

//     setInputValues({
//       ...inputValues,
//       center_id: selectedOption.value, // Store selected center_id
//     });

//     // Remove selected center from the list of options
//     setOptions((prevOptions) =>
//       prevOptions.filter((option) => option.value !== selectedOption.value)
//     );
//   };

//   useEffect(() => {
//     center_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   useEffect(() => {
//     roles();
//   }, []);

//   const roles = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/role_id`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setRoptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const center_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/center_id`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }

//       console.log(namelist);
//       setOptions(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     // Convert selected roles to a comma-separated string of IDs
//     const roleIds = selectedRoles.map((role) => role.value).join(",");

//     const formData = new FormData();
//     formData.append("id", cooId);
//     formData.append("center_id", inputValues.center_id);
//     formData.append("name", inputValues.name);
//     formData.append("role_id", roleIds); // Fix here
//     formData.append("email", inputValues.email);
//     formData.append("phone_no", inputValues.phone_no);
//     formData.append("password", inputValues.password);
//     formData.append("status", parseInt(inputValues.status));

//     console.log("Form Data:", Object.fromEntries(formData.entries()));

//     try {
//       const response = await fetch(`${serverUrl}/upd_user/${cooId}`, {
//         method: "PUT",
//         body: formData,
//       });

//       const data = await response.json();
//       console.log("Response from API", data);

//       if (data.code >= 400) {
//         if (typeof data.message === "object") {
//           Object.entries(data.message).forEach(([field, errors]) => {
//             errors.forEach((errMsg) => {
//               toast.error(`${field}: ${errMsg}`);
//             });
//           });
//         } else {
//           toast.error(data.message || "An error occurred.");
//         }
//         // Reload select options again after error
//         center_name();
//         roles();
//       } else {
//         toast.success("COO updated successfully!");
//         setTimeout(() => {
//           navigate(`/coo`);
//         }, 1000);
//       }
//     } catch (error) {
//       console.error("Error updating:", error);
//       toast.error("Something went wrong while updating!");
//     }
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         // file
//                                     }
//                                     alt=""
//                                     className="itemImg"
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {cooInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "role_id" ? (
//                         <Select
//                           options={roptions}
//                           name={input.fieldName}
//                           isMulti
//                           value={selectedRoles}
//                           isDisabled={true}
//                           isClearable={false}
//                         />
//                       ) : input.fieldName === "center_id" ? (
//                         <Select
//                           options={options}
//                           name={input.fieldName}
//                           value={selectedoptions}
//                           onChange={handleCenterSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/categories/${cooId}`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/coo`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer />
//     </>
//   );
// };

// export default COOUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { cooInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const COOUpdate = ({ title }) => {
  const location = useLocation();
  const cooId = location.pathname.match(/\/update-coo\/(\d+)/)?.[1];
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [roptions, setRoptions] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([{ value: "2", label: "COO" }]);
  const [selectedStatus, setSelectedStatus] = useState(null);

  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchCOO = async () => {
      try {
        const response = await fetch(`${serverUrl}/user/${cooId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const data = await response.json();

        const rnames = data.data.role_names.split(",");
        const rid = data.data.role_id.split(",");
        const roleList = rnames.map((name, i) => ({
          value: rid[i],
          label: name,
        }));

        setSelectedOptions({
          value: data.data.center_id,
          label: data.data.center_name,
        });

        setSelectedStatus(
          statusOptions.find((opt) => opt.value == data.data.status)
        );

        setSelectedRoles(roleList);
        setInputValues(data.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch COO data.");
      }
    };

    if (cooId) {
      fetchCOO();
    }
  }, [cooId]);

  const handleRoleSelectChange = (selectedOptions) => {
    setSelectedRoles(selectedOptions);
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleCenterSelectChange = (selectedOption) => {
    setSelectedOptions(selectedOption);
    setInputValues({
      ...inputValues,
      center_id: selectedOption.value,
    });
  };

  useEffect(() => {
    center_name();
    roles();
  }, []);

  const roles = async () => {
    try {
      const response = await fetch(`${serverUrl}/role_id`);
      if (!response.ok) {
        throw new Error("Failed to fetch roles");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setRoptions(namelist);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to fetch roles data.");
    }
  };

  const center_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/center_id`);
      if (!response.ok) {
        throw new Error("Failed to fetch center data");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setOptions(namelist);
    } catch (error) {
      console.error("Error fetching center data:", error);
      toast.error("Failed to fetch center data.");
    }
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const roleIds = selectedRoles.map((role) => role.value).join(",");

    const formData = new FormData();
    formData.append("id", cooId);
    formData.append("center_id", inputValues.center_id);
    formData.append("name", inputValues.name);
    formData.append("role_id", roleIds);
    formData.append("email", inputValues.email);
    formData.append("phone_no", inputValues.phone_no);
    formData.append("password", inputValues.password);
    formData.append("status", parseInt(inputValues.status));

    try {
      const response = await fetch(`${serverUrl}/upd_user/${cooId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("COO updated successfully!");
        setTimeout(() => {
          navigate("/coo");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {cooInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "role_id" ? (
                              <Select
                                options={roptions}
                                isMulti
                                value={selectedRoles}
                                onChange={handleRoleSelectChange}
                                isDisabled={true}
                                isClearable={false}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "center_id" ? (
                              <Select
                                options={options}
                                value={selectedOptions}
                                onChange={handleCenterSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/coo")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update COO
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default COOUpdate;